export type TicketStage = "new" | "pending" | "success" | "failure";

export const TICKET_STAGE_ORDER: TicketStage[] = ["new", "pending", "success", "failure"];

export const TICKET_STAGE_META: Record<
  TicketStage,
  { label: string; hint?: string; accent: string }
> = {
  new: {
    label: "Nuevos",
    accent: "bg-sky-50/60 border-sky-200",
  },
  pending: {
    label: "En proceso",
    hint: "Atendidos por asesores humanos",
    accent: "bg-amber-50/60 border-amber-200",
  },
  success: {
    label: "Cerrados",
    accent: "bg-emerald-50/60 border-emerald-200",
  },
  failure: {
    label: "Cerrados sin éxito",
    accent: "bg-rose-50/60 border-rose-200",
  },
};

export const TICKET_PRIORITY_COLORS: Record<string, string> = {
  urgent: "bg-red-100 text-red-700",
  high: "bg-orange-100 text-orange-700",
  medium: "bg-gray-100 text-gray-600",
  low: "bg-blue-100 text-blue-700",
};

export const TICKET_PRIORITY_DISPLAY_NAMES: Record<string, string> = {
  low: "Baja",
  medium: "Media",
  high: "Alta",
  urgent: "Urgente",
};

/** Maps pipeline IDs to agent topics for fetching categories */
export const PIPELINE_AGENT_TOPIC: Record<string, string> = {
  general: "rentals-inquiries",
  maintenance: "rentals-maintenance",
  default: "rentals-sales",
  sourceproperties: "rentals-sourceproperties",
  collections: "rentals-collections",
};
